// Import required libraries
import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

// Import styles
import "../../components/AppRow/AppRow.scss";

// Import custom components
import AppCard from "../../components/AppCard/AppCard.js";
import noDataImage from "../../../assets/images/undraw_empty.svg";

// Import utils
import { config } from "../../config/config";

function AdminAppRow(props) {
  let { data, title, user, match, customClassName } = props;
  let sortedData = data;

  return (
    <div
      className={`${user.theme} apps-row ${
        customClassName ? customClassName : ""
      }`}
    >
      {title && <h1 className="apps-row-title">{title}</h1>}
      {data.length ? (
        <div
          className={`apps-row-grid ${customClassName ? customClassName : ""}`}
        >
          {sortedData.map((obj, index) => (
            <AppCard
              key={index}
              config={obj}
              name={obj.id}
              match={match}
              popOverFlag={false}
              allAppsFlag={false}
              customClassName={customClassName}
              isAdminPanel={true}
            />
          ))}
        </div>
      ) : (
        <div className="no-apps">
          <img src={noDataImage} />
          <p className="no-data">
            <b>{config.messages.noApps}</b>
          </p>
        </div>
      )}
    </div>
  );
}

AdminAppRow.propTypes = {
  title: PropTypes.string,
  data: PropTypes.array.isRequired,
  user: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({ user: state.user });

export default connect(mapStateToProps)(AdminAppRow);
